/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsDeleteOrgAutoModel } from "../../funcs/llmModelsDeleteOrgAutoModel.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteOrgAutoModelRequest$inboundSchema,
};

export const tool$llmModelsDeleteOrgAutoModel: ToolDefinition<typeof args> = {
  name: "llm-models-delete-org-auto-model",
  description: `Clear this org's auto-model override for an endpoint

Removes the per-org override for the endpoint. Subsequent \`model: "auto"\` requests fall through to the operator's YAML default again.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsDeleteOrgAutoModel(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
